// extracted by mini-css-extract-plugin
module.exports = {"badge":"MobilizeBadge_badge__rg4jS","logo":"MobilizeBadge_logo__3kd56","large":"MobilizeBadge_large__kY0u1"};